import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';

import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Global from '../../../../store/global-selectors';
import style from './style.module.less';
import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import { FormattedMessage } from 'react-intl';
import { ShippingStrategyDefaultTagWithName } from '../../../shipping-strategy-default-tag/shipping-strategy-default-tag-with-name';
import { messages } from '../messages';

export const RateShopperColumn = ({ fulfillmentPlanId }) => {
  const { rateSummary, labelConfiguration } = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId }),
  );
  const { serviceCollectionGuid } = labelConfiguration ?? {};
  const { rateError } = rateSummary ?? {};
  const serviceCollections = useSelector(Global.selectSellerServiceCollections);
  const selectedServiceCollection = serviceCollections.find((collection) => collection.serviceCollectionGuid === serviceCollectionGuid);

  const templateColumn = (
    <div className={style['shopper-template']}>
      <ShippingStrategyDefaultTagWithName name={selectedServiceCollection?.name} />
    </div>
  );

  if (!selectedServiceCollection) {
    return '';
  }
  if (!rateError) {
    return selectedServiceCollection?.isTemplate ? templateColumn : selectedServiceCollection.name;
  }
  return (
    <div className={style['rate-shopper-cell']}>
      {rateError && (
        <Tooltip position='bottom'>
          <div className={style['icon-wrapper']}>
            <FontAwesomeIcon className={style['error-icon']} icon={faExclamationCircle} />
          </div>
          <TooltipContent>
            <FormattedMessage {...messages.rateShopperCellErrorMessage} />
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  );
};

RateShopperColumn.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};
